import type { Infer } from 'superstruct';
import { partial, pick } from 'superstruct';

import { ViewGoogleAdsCampaignBudgetTemplateDto } from '@adflow/shared/data-google-ads';

export const HistoryGoogleAdsBudgetDto = partial(
	pick(ViewGoogleAdsCampaignBudgetTemplateDto, [
		'id',
		'budget',
		'avbId',
		'label',
	])
);

export type HistoryGoogleAdsBudgetDto = Infer<typeof HistoryGoogleAdsBudgetDto>;
